import { defineField, defineType } from 'sanity'

export default defineType({
  name: 'infoSubNav',
  title: 'Info Sub Nav',
  type: 'object',
  fields: [
    defineField({
      title: 'Nav Groups',
      name: 'items',
      type: 'array',
      of: [{ type: 'navGroupItem' }],
    }),
    defineField({
      title: 'Nav Info',
      name: 'info',
      type: 'navInfo',
    }),
  ],
})